import React from 'react';
import classes from './Legend.scss';

const Legend = ({ children }) => (
    <legend className={classes.Legend}>{children}</legend>
);

export default Legend;
